module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "logo_horizontal.430beba6.svg";